import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#012169"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 4l24 16M24 4L4 20",
			stroke: "#ffffff",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 4l24 16M24 4L4 20",
			stroke: "#c8102e",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 0v24M0 12h24",
			stroke: "#ffffff",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 0v24M0 12h24",
			stroke: "#c8102e",
			strokeWidth: 2
		})
	]
});
export default SvgEn;
